import React from 'react';
import { FaArrowRight } from 'react-icons/fa';

export default function Hero() {
  return (
    <section
      className="relative min-h-[80vh] flex items-center justify-center bg-black"
      style={{ minHeight: '100vh' }}
    >
      {/* Tübitak ve KOSGEB logoları */}
      <div className="absolute right-4 top-4 flex flex-col gap-4 z-30">
        <img
          src="/tubitak-logo.png"
          alt="Tübitak Logo"
          className="w-[120px] h-[96px] object-contain shadow-lg rounded-xl bg-white/90 backdrop-blur-sm p-3"
        />
        <img
          src="/kosgeb-logo.png"
          alt="KOSGEB Logo"
          className="w-[120px] h-[96px] object-contain shadow-lg rounded-xl bg-white/90 backdrop-blur-sm p-3"
        />
      </div>
      {/* Arka plan görseli ve karartı */}
      <img
        src="/hero-2.jpg"
        alt="SolarTools Dashboard"
        className="absolute inset-0 w-full h-full object-cover z-0"
        style={{ filter: 'brightness(0.50)' }}
      />
      <div className="absolute inset-0 bg-black/50 z-10" />

      {/* Ortalanmış içerik */}
      <div className="relative z-20 flex flex-col items-center justify-center text-center px-4">
        <h1 className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-extrabold text-white leading-tight mb-6 drop-shadow-lg">
          Enerjinizi tek bir platformdan yönetin
        </h1>
        <p className="text-lg md:text-xl text-white/90 mb-8 max-w-xl drop-shadow">
          Güneş enerjisi sistemlerinizi akıllı panolarla izleyin, analiz edin ve optimize edin.
        </p>
        <div className="flex flex-wrap gap-4 justify-center">
          <button className="bg-[var(--color-primary)] hover:bg-[var(--color-secondary)] text-white font-semibold px-8 py-4 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 text-lg flex items-center gap-2">
            Hemen Ücretsiz Dene
            <FaArrowRight className="text-xl" />
          </button>
          <button className="bg-white hover:bg-gray-50 text-[var(--color-primary)] font-semibold px-8 py-4 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 text-lg border-2 border-[var(--color-primary)]">
            Detaylar
          </button>
        </div>
      </div>
      
    </section>
  );
}
